/**
 * 采集用户鼠标点击事件的信息
 * 未避免数据量过多，只采集特定用户鼠标行为数据
 */
import bus from 'public/utils/bus'
import { getXPath } from 'public/utils/common'
import { isQtReportWhiteList } from '@/layout/utils/report-qt.js'

bus.$once('APP_LOADED', init)

function init() {
  setTimeout(() => {
    const needReport = isQtReportWhiteList()
    if (needReport) {
      document.addEventListener('mousedown', reportData)
    }
  }, 1000)
}

function reportData(e) {
  try {
    setTimeout(() => {
      const className = (e.target && e.target.className) || ''
      const xpath = getXPath(e.target) || ''
      const detail = {
        dom: window.__ERP_LASTEVENT__,
        lastTag: window.__ERP_LASTTAG__,
        class: className,
        xpath,
        url: location.href
      }
      window.aplus_queue && window.aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['erp_common_mouse_down', 'OTHER', {
          detail: JSON.stringify(detail)
        }]
      })
    })
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/report-mousedown.js